module.exports = __webpack_public_path__ + "static/media/tanabxazindagi.5330717d.png";